const finiteOr = (value, fallback = 0) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};

const resolveInsets = (bounds = {}) => {
  const gutter = Math.max(0, finiteOr(bounds.gutter, 8));
  return {
    left: Math.max(0, finiteOr(bounds.leftInset, gutter)),
    right: Math.max(0, finiteOr(bounds.rightInset, gutter)),
    top: Math.max(0, finiteOr(bounds.topInset, gutter)),
    bottom: Math.max(0, finiteOr(bounds.bottomInset, gutter)),
  };
};

export const clampFloatingToolRailPosition = (position = {}, bounds = {}) => {
  const viewportWidth = Math.max(0, finiteOr(bounds.viewportWidth));
  const viewportHeight = Math.max(0, finiteOr(bounds.viewportHeight));
  const railWidth = Math.max(0, finiteOr(bounds.railWidth));
  const railHeight = Math.max(0, finiteOr(bounds.railHeight));
  const insets = resolveInsets(bounds);

  const fitsWidth = viewportWidth >= railWidth + insets.left + insets.right;
  const fitsHeight = viewportHeight >= railHeight + insets.top + insets.bottom;
  const minX = fitsWidth ? insets.left : 0;
  const minY = insets.top;
  const maxX = fitsWidth ? viewportWidth - railWidth - insets.right : 0;
  const maxY = fitsHeight ? viewportHeight - railHeight - insets.bottom : insets.top;

  return {
    x: Math.round(Math.min(maxX, Math.max(minX, finiteOr(position.x, minX)))),
    y: Math.round(Math.min(maxY, Math.max(minY, finiteOr(position.y, minY)))),
  };
};

export const floatingToolRailSafeBandAvailable = (bounds = {}, minimumRailHeight = 32) => {
  const viewportHeight = Math.max(0, finiteOr(bounds.viewportHeight));
  const insets = resolveInsets(bounds);
  return viewportHeight >= insets.top + insets.bottom + Math.max(0, finiteOr(minimumRailHeight, 32));
};

export const defaultFloatingToolRailPosition = (bounds = {}) => {
  const viewportWidth = Math.max(0, finiteOr(bounds.viewportWidth));
  const viewportHeight = Math.max(0, finiteOr(bounds.viewportHeight));
  const railWidth = Math.max(0, finiteOr(bounds.railWidth));
  const railHeight = Math.max(0, finiteOr(bounds.railHeight));
  const insets = resolveInsets(bounds);
  const availableHeight = Math.max(0, viewportHeight - insets.top - insets.bottom);
  const horizontalEdge = bounds.horizontalEdge === 'left' ? 'left' : 'right';
  return clampFloatingToolRailPosition({
    x: horizontalEdge === 'left' ? insets.left : viewportWidth - railWidth - insets.right,
    y: insets.top + Math.max(0, (availableHeight - railHeight) / 2),
  }, bounds);
};
